import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, EventMessage, EventType } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { FooterComponent } from './footer.component';
import { HeaderComponent } from './header.component';

@Component({
  selector: 'app-root',
  template: `
  <header class="navbar sticky-top bg-syk-yellow mb-3">
    <app-header class="container-fluid" />
  </header>
  
  <main>
    <router-outlet />
  </main>

  <footer class="bg-syk-grey mt-3">
    <app-footer class="container-fluid" />
  </footer>
  `,
  styles: `
  :host {
    box-sizing: border-box;
    min-height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  header,
  footer {
    flex-grow: 0;
    flex-shrink: 0;
  }
  
  main {
    flex-grow: 1;
  }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet, HeaderComponent, FooterComponent]
})
export class AppComponent {
  private readonly msalService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);

  constructor() {
    this.msalService.handleRedirectObservable().subscribe();

    this.msalBroadcastService.msalSubject$.pipe(
      takeUntilDestroyed(),
      filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS)
    ).subscribe((result: EventMessage) => {
      const account = result.payload as AccountInfo;
      this.msalService.instance.setActiveAccount(account);
    });
  }
}
